export default __webpack_public_path__ + "static/media/5l-act.1df23d9c.svg";